import { cn, MembershipBadge } from '@yanolja-rnd/nol-design-system'
import { MembershipBadgeSizeType } from '@yanolja-rnd/nol-design-system/dist/components/badge/badge.types'
import { toKRW } from '~/app/utils/krNumberToString'

interface GoldClassDiscountBadgeProps {
  discountPrice: number
  badgeSize: MembershipBadgeSizeType
  className?: string
}

const GoldClassDiscountBadge = ({
  discountPrice,
  className,
  badgeSize,
}: GoldClassDiscountBadgeProps) => {
  if (!discountPrice) return null

  return (
    <div className={cn('flex justify-end', className)}>
      <MembershipBadge
        size={badgeSize}
        type="gold_special_price"
        className="typography-caption-11-bold"
      >
        특가 <span className="text-static-white">{toKRW(discountPrice)} 할인받았어요.</span>
      </MembershipBadge>
    </div>
  )
}

export default GoldClassDiscountBadge
